import React, { useState } from "react";
import { Handshake, Send } from "lucide-react";
import api from "../api/api";
import toast from "react-hot-toast";

const PartnershipPage = () => {
  const [form, setForm] = useState({
    organization_name: "",
    contact_person: "",
    email: "",
    phone: "",
    partnership_type: "",
    message: "",
    honeypot: "",
  });

  const submit = async (e) => {
    e.preventDefault();

    try {
      await api.post("/partnerships", form);
      toast.success("Partnership request submitted successfully");

      setForm({
        organization_name: "",
        contact_person: "",
        email: "",
        phone: "",
        partnership_type: "",
        message: "",
        honeypot: "",
      });
    } catch (err) {
      toast.error(err.cleanMessage || "Partnership request failed");
    }
  };

  return (
    <main className="bg-slate-50">
      <section className="pt-32 pb-20 bg-[#06183f] text-white">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-3 mb-5">
            <span className="w-10 h-[3px] bg-[#ff6600]" />
            <span className="text-[#ff6600] font-bold tracking-[0.2em] text-sm uppercase">
              Partnership Desk
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl font-black" style={{ fontFamily: "'Alegreya Sans', sans-serif" }}>
            Partner With AKSUBEB
          </h1>

          <p className="text-white/80 mt-5 max-w-3xl mx-auto leading-relaxed">
            Submit partnership requests for school support, digital learning, infrastructure, training and community education development.
          </p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 py-16">
        <form onSubmit={submit} className="bg-white rounded-[34px] p-6 md:p-8 shadow-xl border border-slate-100">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-14 h-14 rounded-2xl bg-[#ff6600]/10 text-[#ff6600] flex items-center justify-center">
              <Handshake size={26} />
            </div>

            <div>
              <h2 className="text-2xl font-black text-[#06183f]">
                Partnership Request Form
              </h2>
              <p className="text-slate-500 text-sm">
                Tell us how your organization wants to support basic education.
              </p>
            </div>
          </div>

          <input type="text" value={form.honeypot} onChange={(e) => setForm({ ...form, honeypot: e.target.value })} className="hidden" tabIndex="-1" autoComplete="off" />

          <div className="grid md:grid-cols-2 gap-4">
            <input required placeholder="Organization Name" value={form.organization_name} onChange={(e) => setForm({ ...form, organization_name: e.target.value })} className="border border-slate-200 rounded-2xl px-4 py-3 outline-none focus:border-[#06183f]" />

            <input required placeholder="Contact Person" value={form.contact_person} onChange={(e) => setForm({ ...form, contact_person: e.target.value })} className="border border-slate-200 rounded-2xl px-4 py-3 outline-none focus:border-[#06183f]" />

            <input required type="email" placeholder="Email Address" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="border border-slate-200 rounded-2xl px-4 py-3 outline-none focus:border-[#06183f]" />

            <input placeholder="Phone Number" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="border border-slate-200 rounded-2xl px-4 py-3 outline-none focus:border-[#06183f]" />

            <select required value={form.partnership_type} onChange={(e) => setForm({ ...form, partnership_type: e.target.value })} className="md:col-span-2 border border-slate-200 rounded-2xl px-4 py-3 outline-none focus:border-[#06183f]">
              <option value="">Select Partnership Type</option>
              <option>School Infrastructure Support</option>
              <option>Digital Learning / ICT</option>
              <option>Teacher Training</option>
              <option>Pupil Welfare Support</option>
              <option>Learning Materials Donation</option>
              <option>Community Education Initiative</option>
              <option>Other</option>
            </select>
          </div>

          <textarea required rows="7" placeholder="Partnership Proposal / Message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-4 w-full border border-slate-200 rounded-2xl px-4 py-3 outline-none focus:border-[#06183f]" />

          <button className="mt-6 inline-flex items-center gap-2 px-7 py-4 rounded-2xl bg-[#06183f] hover:bg-[#ff6600] text-white font-black transition-colors">
            Submit Partnership Request <Send size={18} />
          </button>
        </form>
      </section>
    </main>
  );
};

export default PartnershipPage;